import Cookies from 'js-cookie';

export default class CookieList {
	#name;

	constructor(name) {
		this.#name = name;
	}

	add(id) {
		let list = this.getList();
		list = list.filter(_id => id !== +_id);
		list.push(id);
		this.setList(list);
	}

	remove(id) {
		let list = this.getList();
		list = list.filter(_id => id !== +_id);
		this.setList(list);
	}

	count() {
		return this.getList().length;
	}

	getList() {
		let rawList = Cookies.get(this.#name);

		if (rawList) {
			return rawList.split(',');
		} else {
			return [];
		}
	}

	setList(list) {
		Cookies.set(this.#name, list.join(','), {expires: 31});
	}
}
